import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_18.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/worklife');
  const shareText = encodeURIComponent('Work-Life Balance Examples to Boost Employee Engagement!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Work Life Balanace — Outstanding Workplaces</title>
        <meta property="og:title" content="Work Life Balanace — Outstanding Workplaces" />
        <meta property="og:description" content="Work-Life Balance Examples to Boost Employee Engagement" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778052541/i_18_hueuhz.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/worklife" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Work Life Balanace — Outstanding Workplaces" />
        <meta name="twitter:description" content="Work-Life Balance Examples to Boost Employee Engagement" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778052541/i_18_hueuhz.jpg" />
      </Helmet>

       <div className="sight_18_page_wrapper">
        <div className="sight_18_content_container">

          <div className="sight_18_section_one">

            <h1 className="sight_18_page_title">
             Work-Life Balance Examples to Boost Employee Engagement
            </h1>

            <div className="sight_18_row">

              <div className="sight_18_left">
                <div className="sight_18_image_wrapper">
                  <img src="/assets/i_18.jpg" alt="Team meeting discussion" className="sight_18_blog_image" />
                </div>

                {/* SHARE SECTION */}
                <div className="sight_18_share_section">
                  <span className="sight_18_share_text">Share :</span>
                  <div className="sight_18_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_18_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_18_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_18_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_18_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

           <div className="sight_18_para_wrapper">
                  <h2 className="sight_18_para_title">
                    Why Work-Life Balance Matters for Employee Engagement
                  </h2>
                  <p className="sight_18_para_intro">
                    When employees feel supported in balancing work and personal life, they are:
                  </p>
                  <ul className="sight_18_para_list">
                    <li>More productive and focused</li>
                    <li>Less stressed and burned out</li>
                    <li>More committed to organizational goals</li>
                    <li>Likely to stay longer with the company</li>
                  </ul>
                </div>

              </div>

              <div className="sight_18_right">
                <div className="sight_18_ad_card">
                  <img src="/assets/bc_1.png" className="sight_18_ad_bg" />
                  <div className="sight_18_ad_overlay"></div>
                  <img src="/assets/bg_1.png" className="sight_18_ad_badge" />

                  <div className="sight_18_ad_content">
                    <h2>
                      Earn the Outstanding <br />
                      <span>Workplaces Certification</span>
                    </h2>
                    <ul>
                      <li>Attract Top Talent</li>
                      <li>Boost Employee Engagement</li>
                      <li>Drive Culture-Led Growth</li>
                    </ul>
                    <button
                      className="sight_18_ad_btn"
                      onClick={() => window.location.href = '/nominate'}
                    >
                      Get Certificate
                    </button>
                  </div>
                </div>
              </div>

            </div>

            {/* para_footer outside row - spans full width */}
            <p className="sight_18_para_footer">
              A healthy balance fosters a positive workplace culture where employees feel valued-not just as workers, but as individuals.
            </p>

          </div>

          <div className="sight_18_section">
            <div className="sight_18_topics">

              <h2 className="sight_18_main_title">
                7 Work-Life Balance Examples That Boost Engagement
              </h2>

              <div className="sight_18_topic_item">
                <h3 className="sight_18_topic_heading">1. Flexible Work Hours</h3>
                <ul className="sight_18_topic_list">
                  <li>
                    Allowing employees to choose their working hours helps them manage personal commitments more effectively. Flexibility builds trust and empowers employees to work when they are most productive.
                  </li>
                  <li>
                    <strong>Impact:</strong> Higher job satisfaction and reduced absenteeism.
                  </li>
                </ul>
              </div>

              <div className="sight_18_topic_item">
                <h3 className="sight_18_topic_heading">2. Remote & Hybrid Work Options</h3>
                <ul className="sight_18_topic_list">
                  <li>
                    Offering remote or hybrid work models enables employees to save commuting time and create a comfortable work environment.
                  </li>
                  <li>
                    <strong>Impact:</strong> Increased productivity and better mental well-being.
                  </li>
                </ul>
              </div>

              <div className="sight_18_topic_item">
                <h3 className="sight_18_topic_heading">3. Encouraging Time Off</h3>
                <ul className="sight_18_topic_list">
                  <li>
                    Organizations that actively encourage employees to take leave—without guilt—help prevent burnout and improve overall morale.
                  </li>
                  <li>
                    <strong>Example:</strong> Mandatory vacation policies or "no-meeting days."
                  </li>
                  <li>
                    <strong>Impact:</strong> Refreshed employees who return more engaged and creative.
                  </li>
                </ul>
              </div>

              <div className="sight_18_topic_item">
                <h3 className="sight_18_topic_heading">4. Wellness Programs</h3>
                <ul className="sight_18_topic_list">
                  <li>
                    Providing wellness initiatives such as mental health support, fitness programs, or stress management workshops shows employees that their well-being matters.
                  </li>
                  <li>
                    <strong>Impact:</strong> Reduced stress and stronger emotional connection to the workplace.
                  </li>
                </ul>
              </div>

              <div className="sight_18_topic_item">
                <h3 className="sight_18_topic_heading">5. Clear Boundaries Between Work & Personal Time</h3>
                <ul className="sight_18_topic_list">
                  <li>
                    Encouraging employees to disconnect after work hours (no emails or calls) helps maintain a healthy boundary.
                  </li>
                  <li>
                    <strong>Example:</strong> "Right to disconnect" policies.
                  </li>
                  <li>
                    <strong>Impact:</strong> Improved focus during working hours and better work-life harmony.
                  </li>
                </ul>
              </div>

              <div className="sight_18_topic_item">
                <h3 className="sight_18_topic_heading">6. Family-Friendly Policies</h3>
                <ul className="sight_18_topic_list">
                  <li>
                    Policies like parental leave, childcare support, or family health benefits make a huge difference for employees with families.
                  </li>
                  <li>
                    <strong>Impact:</strong> Stronger loyalty and long-term commitment.
                  </li>
                </ul>
              </div>

              <div className="sight_18_topic_item">
                <h3 className="sight_18_topic_heading">7. Recognition of Personal Time & Effort</h3>
                <ul className="sight_18_topic_list">
                  <li>
                    Recognizing employees not just for performance but also respecting their time creates a culture of appreciation.
                  </li>
                  <li>
                    <strong>Example:</strong> Avoiding last-minute deadlines or weekend work unless necessary
                  </li>
                  <li>
                    <strong>Impact:</strong> Increased trust and emotional engagement.
                  </li>
                </ul>
              </div>

              <div className="sight_18_topic_item">
                <h3 className="sight_18_topic_heading">
                  How HR Leaders Can Drive Work-Life Balance
                </h3>
                <p className="sight_18_topic_subtext">
                  To make work-life balance effective, organizations should:
                </p>
                <ul className="sight_18_topic_list">
                  <li>Lead by example-managers must model balanced behavior</li>
                  <li>Regularly gather employee feedback</li>
                  <li>Customize policies based on workforce needs</li>
                  <li>Integrate balance into company culture, not just policies</li>
                </ul>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default BlogPage;